const NotFound = () => {
    return (
        <>
            <div className="flex justify-center p-16">
                <h3 className="text-pink-600 text-4xl">Please Content Software Owner !</h3>
            </div>
        </>
    );
}

export default NotFound;